<div class="main">
  <div class="main-content">
    <div class="p-fluid p-formgrid p-grid chat-screen">
      <!-- LIST GROUP CHAT -->
      <div class="p-col-3 list-message-arrive" #listPanelChat [ngClass]="{'w-100':!detailOpen, 'w-0':detailOpen}">
        <div *ngIf="classId == '9'">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-col-12">
              <form [formGroup]="c601SearchForm" (ngSubmit)="_loadChatHistory(true)">
                <div class="p-d-flex box-freeword">
                  <div class="input-icon-container">
                    <input title="フリーワード検索" type="text" pInputText class="freeword-inputtext"
                      [formControl]="c601SearchForm.controls.freeword" />
                    <i class="pi pi-search search-icon"></i>
                  </div>
                </div>
                <p-accordion [multiple]="true">
                  <p-accordionTab header="団体種別"                 
                    [(selected)]="accordion_member_class_sub" aria-label="団体種別">
                    <p-accordionTab header="中学校・高校等"
                      [(selected)]="accordion_member_class_sub_id" aria-label="中学校・高校等">
                      <div class="accrodion-form-list">
                        <div class="btn-check">
                          <span><a href="#" (click)="$event.preventDefault();
                                checkLargeCategory(
                                  'checkAll',
                                  getDicList(81),
                                  'member_class_sub_id'
                                )
                              ">すべて選択</a> </span>　|　
                          <span class="p-ml-2"><a href="#" (click)="$event.preventDefault();
                                checkLargeCategory(
                                  'removeAll',
                                  getDicList(81),
                                  'member_class_sub_id'
                                )
                              ">解除</a></span>
                        </div>
                        <div *ngFor="let dicData of getDicList(81)">
                          <p-checkbox [label]="dicData.sp_name" [value]="dicData.sp_code" [formControl]="
                              c601SearchForm.controls
                                .member_class_sub_id
                            " aria-label="{{ dicData.sp_name }}"></p-checkbox>
                        </div>
                      </div>
                    </p-accordionTab>
                    <p-accordionTab header="保育所・幼稚園等"
                      [(selected)]="accordion_member_class_sub_id_2" aria-label="保育所・幼稚園等">
                      <div class="accrodion-form-list">
                        <div class="btn-check">
                          <span><a href="#" (click)="$event.preventDefault();
                                checkLargeCategory(
                                  'checkAll',
                                  getDicList(83),
                                  'member_class_sub_id_2'
                                )
                              ">すべて選択</a> </span>　|　
                          <span class="p-ml-2"><a href="#" (click)="$event.preventDefault();
                                checkLargeCategory(
                                  'removeAll',
                                  getDicList(83),
                                  'member_class_sub_id_2'
                                )
                              ">解除</a></span>
                        </div>
                        <div *ngFor="let dicData of getDicList(83)">
                          <p-checkbox [label]="dicData.sp_name" [value]="dicData.sp_code" [formControl]="
                              c601SearchForm.controls
                                .member_class_sub_id_2
                            " aria-label="{{ dicData.sp_name }}"></p-checkbox>
                        </div>
                      </div>
                    </p-accordionTab>
                  </p-accordionTab>
                  <p-accordionTab header="所在地(市区町村)"
                    [(selected)]="accordion_member_municipalities" aria-label="所在地(市区町村)">
                    <div class="accrodion-form-list">
                      <div class="btn-check">
                        <span><a href="#" (click)="$event.preventDefault();
                                checkLargeCategory(
                                  'checkAll',
                                  getDicList(2016),
                                  'member_municipalities'
                                )
                              ">すべて選択</a> </span>　|　
                        <span class="p-ml-2"><a href="#" (click)="$event.preventDefault();
                                checkLargeCategory(
                                  'removeAll',
                                  getDicList(2016),
                                  'member_municipalities'
                                )
                              ">解除</a></span>
                      </div>
                      <div *ngFor="let dicData of getDicList(2016)">
                        <p-checkbox [label]="dicData.sp_name" [value]="dicData.sp_code" [formControl]="
                              c601SearchForm.controls
                                .member_municipalities
                            " aria-label="{{ dicData.sp_name }}"></p-checkbox>
                      </div>
                    </div>
                  </p-accordionTab>
                </p-accordion>
              </form>
            </div>
            <div class="p-col-12 btn-block-search">
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-col-12">
                  <button pButton type="button" label="検索" class="p-button-danger btn-search-item"
                    (click)="_loadChatHistory(true)"></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid message-item" *ngFor="let chatCommon of listChatCommon" [ngClass]="{
            'focus-message': (classId != '9' && matchId == chatCommon.match_id && consultationId == chatCommon.consultation_id) || (classId == '9' && matchId == chatCommon.match_id && isMatchingChat) || (classId == '9' && consultationId == chatCommon.consultation_id && !isMatchingChat)
          }">
          <div *ngIf="chatCommon.consultation_id == ''" class="item-chat" (click)="
              openDetailChat(chatCommon.match_id, chatCommon?.count_unread, chatCommon.consultation_id); resetChat();
            ">
            <div class="p-col-2 arrive-item-img center p-p-0">
              <img [src]="chatCommon.icon_image" alt="Img-Chat" width="90%" class="message-img" />
            </div>
            <div class="p-col-8 arrive-item-desc">
              <!-- <span *ngIf="classId == '1' || classId == '2'"
                class="func-name text-sub-size letter-spacing-1 pink-color-c231">{{chatCommon.member_class_sub_id}}
              </span>
              <div class="item-desc-detail bold" *ngIf="classId == '1'">
                {{ chatCommon.needs_organization_name }}
              </div>
              <div class="item-desc-detail bold" *ngIf="classId == '2'">
                {{ chatCommon.seeds_organization_name }}
              </div>
              <div *ngIf="classId == '1' || classId == '2'" class="item-desc-location">
                {{ chatCommon.oneword_message }}
              </div> -->
              <div class="item-desc-detail" >希望登録団体：</div>
              <div class="item-desc-detail bold">
                {{ chatCommon.match_type == '1' ? chatCommon.needs_organization_name :
                chatCommon.seeds_organization_name }}
              </div>
              <div class="item-desc-detail mt-6">マッチング依頼団体：</div>
              <div class="item-desc-detail bold">
                {{ chatCommon.match_type == '2' ? chatCommon.needs_organization_name :
                chatCommon.seeds_organization_name }}
              </div>
            </div>
            <div class="p-col-2 arrive-item-quality center" *ngIf="chatCommon.count_unread !== '0'">
              <ng-container *ngIf="number(chatCommon.count_unread) > 99; else norCount">
                <p-avatar label="99+" shape="circle" styleClass="item-messge-quality"></p-avatar>
              </ng-container>
              <ng-template #norCount>
                <p-avatar [label]="chatCommon.count_unread" shape="circle" styleClass="item-messge-quality"></p-avatar>
              </ng-template>
            </div>
          </div>
          <div *ngIf="chatCommon.consultation_id != '' && classId != '9'" class="item-chat" (click)="
              openDetailChat(chatCommon.match_id, chatCommon?.count_unread, chatCommon.consultation_id); resetChat();
            ">
            <div class="p-col-2 arrive-item-img center p-p-0">
              <img [src]="icon_image_admin" alt="Img-Chat" width="90%" class="message-img" />
            </div>
            <div class="p-col-8 arrive-item-desc">
              <div class="item-desc-detail bold">
                {{ admin_name }}
              </div>
              <div class="item-desc-location">
                {{ admin_sub }}
              </div>
            </div>
            <div class="p-col-2 arrive-item-quality center" *ngIf="chatCommon.count_unread !== '0'">
              <ng-container *ngIf="number(chatCommon.count_unread) > 99; else norCount">
                <p-avatar label="99+" shape="circle" styleClass="item-messge-quality"></p-avatar>
              </ng-container>
              <ng-template #norCount>
                <p-avatar [label]="chatCommon.count_unread" shape="circle" styleClass="item-messge-quality"></p-avatar>
              </ng-template>
            </div>
          </div>
          <div *ngIf="chatCommon.consultation_id != '' && classId == '9'" class="item-chat" (click)="
              openDetailChat('9', chatCommon?.count_unread, chatCommon.consultation_id); resetChat();
            ">
            <div class="p-col-10 arrive-item-desc">
              <div class="item-desc-location">
                {{ chatCommon.municipalities }}
              </div>
              <div class="item-desc-location">
                {{ chatCommon.organization_name }}
              </div>
            </div>
            <div class="p-col-2 arrive-item-quality center" *ngIf="chatCommon.count_unread !== '0'">
              <ng-container *ngIf="number(chatCommon.count_unread) > 99; else norCount">
                <p-avatar label="99+" shape="circle" styleClass="item-messge-quality"></p-avatar>
              </ng-container>
              <ng-template #norCount>
                <p-avatar [label]="chatCommon.count_unread" shape="circle" styleClass="item-messge-quality"></p-avatar>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <!-- /LIST GROUP CHAT -->

      <!-- RIGHT CONTENT -->
      <div class="p-col-9 message-detail" *ngIf="matchId" [ngClass]="{'w-100':detailOpen}">
        <div class="p-fluid p-formgrid p-grid">
          <!-- SEARCH -->
          <form [formGroup]="c601ChatInputForm" class="chat-form" *ngIf="consultationId == ''">
            <div class="p-col-12 info-detail-top">
              <div class="info-top-message-detail">
                <div class="p-fluid p-d-flex p-ai-center p-jc-around" *ngIf="!isMobile">
                  <div class=" p-d-flex p-ai-center chat-detail-status">
                    <span class="letter-spacing-2 p-text-bold p-pr-2 label">ステータス</span>
                    <ng-container *ngIf="
                          (isLoginMember(
                            listMatchChatDetail?.needs_member_id
                          ) ||
                            isLoginMember(
                              listMatchChatDetail?.seeds_member_id
                            ));
                        else elseTemplate
                      ">
                      <div [ngClass]="
                          setClassStatusDropdown(
                            c601ChatInputForm.get('status').value
                          )
                        ">
                        <p-dropdown optionLabel="name"
                          [options]="getListStatusChange(listMatchChatDetail?.status, listMatchChatDetail?.match_type)"
                          optionValue="code" class="drop-down-style-first" formControlName="status"
                          (onChange)="changeStatus($event)" aria-label="ステータスを選ぶ"></p-dropdown>
                      </div>
                    </ng-container>
                    <ng-template #elseTemplate>
                      <div class="statusOther" [ngClass]="setClassStatus(listMatchChatDetail?.status)">
                        {{ listMatchChatDetail?.status_name }}
                      </div>
                    </ng-template>
                  </div>

                  <div class=" p-d-flex p-ai-center p-jc-center ipmlement-date">
                    <span class="letter-spacing-2 center p-text-bold">実施日</span>
                    <div class="p-fluid p-d-flex data">
                      <div class="p-col-6 w-100 center p-px-1">
                        <span class="" *ngIf="
                            !c601ChatInputForm.get('start_implementation_date')
                              .value
                          ">年　月　日</span>
                        <span class="" *ngIf="
                            c601ChatInputForm.get('start_implementation_date')
                              .value
                          ">{{
                          formatDateJapan(
                          c601ChatInputForm.get("start_implementation_date")
                          .value
                          )
                          }}</span>
                      </div>

                      <div class="p-col-1 w-100 center p-px-1">〜</div>
                      <div class="p-col-6 w-100 center p-px-1">
                        <span class="" *ngIf="
                            !c601ChatInputForm.get('end_implementation_date')
                              .value
                          ">年　月　日</span>
                        <span class="" *ngIf="
                            c601ChatInputForm.get('end_implementation_date')
                              .value
                          ">{{
                          formatDateJapan(
                          c601ChatInputForm.get("end_implementation_date")
                          .value
                          )
                          }}</span>
                      </div>
                    </div>
                  </div>
                  <div class=" button ipmlement-date-button">
                    <ng-container *ngIf="
                        (listMatchChatDetail?.status == '1' ||
                          listMatchChatDetail?.status == '2' ||
                          listMatchChatDetail?.status == '0' ||
                          listMatchChatDetail?.status == '3') &&
                        (isLoginMember(listMatchChatDetail?.needs_member_id) ||
                          isLoginMember(listMatchChatDetail?.seeds_member_id))
                      ">
                      <button pButton label="実施日登録" (click)="showTimeDialog()"></button>
                    </ng-container>
                  </div>
                  <div class="button consult-button">
                    <ng-container
                      *ngIf="isLoginMember(listMatchChatDetail?.needs_member_id) || isLoginMember(listMatchChatDetail?.seeds_member_id)">
                      <button
                        *ngIf="!listMatchChatDetail?.consult_status || !['1', '2', '3'].includes(listMatchChatDetail?.consult_status)"
                        pButton label="コーディネーター相談" (click)="openConsultationDialog('add')"
                        class="consult-flg-0"></button>
                      <button
                        *ngIf="['1', '2', '3'].includes(listMatchChatDetail?.consult_status)"
                        pButton label="コーディネーター相談中" (click)="openConsultationDialog('edit')"
                        class="consult-flg-1"></button>
                    </ng-container>
                  </div>
                  <div class="button consult-button">
                    <ng-container *ngIf="classId == '9'">
                      <button
                        *ngIf="listMatchChatDetail?.contente == '' && listMatchChatDetail?.contente_2 == ''"
                        pButton label="コーディネーター相談" (click)="openConsultationDialog('add')"
                        class="consult-flg-0"></button>
                      <button
                        *ngIf="listMatchChatDetail?.contente !== '' || listMatchChatDetail?.contente_2 !== ''"
                        pButton label="コーディネーター相談中" (click)="openConsultationDialog('edit')"
                        class="consult-flg-1"></button>
                    </ng-container>
                  </div>
                </div>
                <div class="p-fluid p-formgrid p-grid" *ngIf="isMobile">
                  <div class="p-d-flex p-ai-center p-col-6 mb-4">
                    <span class="letter-spacing-2 p-text-bold p-pr-2 label">ステータス</span>
                    <ng-container *ngIf="
                          (isLoginMember(
                            listMatchChatDetail?.needs_member_id
                          ) ||
                            isLoginMember(
                              listMatchChatDetail?.seeds_member_id
                            ));
                        else elseTemplate
                      ">
                      <div [ngClass]="
                          setClassStatusDropdown(
                            c601ChatInputForm.get('status').value
                          )
                        ">
                        <p-dropdown optionLabel="name"
                          [options]="getListStatusChange(listMatchChatDetail?.status, listMatchChatDetail?.match_type)"
                          optionValue="code" class="drop-down-style-first" formControlName="status"
                          (onChange)="changeStatus($event)" aria-label="ステータスを選ぶ"></p-dropdown>
                      </div>
                    </ng-container>
                    <ng-template #elseTemplate>
                      <div class="statusOther" [ngClass]="setClassStatus(listMatchChatDetail?.status)">
                        {{ listMatchChatDetail?.status_name }}
                      </div>
                    </ng-template>
                  </div>
                  <div class="p-d-flex p-ai-center button p-col-6 mb-4">
                    <ng-container
                      *ngIf="isLoginMember(listMatchChatDetail?.needs_member_id) || isLoginMember(listMatchChatDetail?.seeds_member_id)">
                      <button
                        *ngIf="!listMatchChatDetail?.consult_status || !['1', '2', '3'].includes(listMatchChatDetail?.consult_status)"
                        pButton label="コーディネーター相談" (click)="openConsultationDialog('add')"
                        class="consult-flg-0"></button>
                      <button
                        *ngIf="['1', '2', '3'].includes(listMatchChatDetail?.consult_status)"
                        pButton label="コーディネーター相談中" (click)="openConsultationDialog('edit')"
                        class="consult-flg-1"></button>
                    </ng-container>
                    <ng-container
                      *ngIf="classId == '9'">
                      <button
                        *ngIf="listMatchChatDetail?.contente == '' && listMatchChatDetail?.contente_2 == ''"
                        pButton label="コーディネーター相談" (click)="openConsultationDialog('add')"
                        class="consult-flg-0"></button>
                      <button
                        *ngIf="listMatchChatDetail?.contente !== '' || listMatchChatDetail?.contente_2 !== ''"
                        pButton label="コーディネーター相談中" (click)="openConsultationDialog('edit')"
                        class="consult-flg-1"></button>
                    </ng-container>
                  </div>

                  <div class="p-d-flex p-ai-center p-col-6">
                    <span class="letter-spacing-2 center p-text-bold">実施日</span>
                    <div class="p-fluid p-d-flex data">
                      <div class="p-col-6 w-100 center p-px-1">
                        <span class="" *ngIf="
                            !c601ChatInputForm.get('start_implementation_date')
                              .value
                          ">年　月　日</span>
                        <span class="" *ngIf="
                            c601ChatInputForm.get('start_implementation_date')
                              .value
                          ">{{
                          formatDateJapan(
                          c601ChatInputForm.get("start_implementation_date")
                          .value
                          )
                          }}</span>
                      </div>

                      <div class="p-col-1 w-100 center p-px-1">〜</div>
                      <div class="p-col-6 w-100 center p-px-1">
                        <span class="" *ngIf="
                            !c601ChatInputForm.get('end_implementation_date')
                              .value
                          ">年　月　日</span>
                        <span class="" *ngIf="
                            c601ChatInputForm.get('end_implementation_date')
                              .value
                          ">{{
                          formatDateJapan(
                          c601ChatInputForm.get("end_implementation_date")
                          .value
                          )
                          }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="p-d-flex p-ai-center button p-col-6">
                    <ng-container *ngIf="
                        (listMatchChatDetail?.status == '1' ||
                          listMatchChatDetail?.status == '2' ||
                          listMatchChatDetail?.status == '0' ||
                          listMatchChatDetail?.status == '3') &&
                        (isLoginMember(listMatchChatDetail?.needs_member_id) ||
                          isLoginMember(listMatchChatDetail?.seeds_member_id))
                      ">
                      <button pButton label="実施日登録" (click)="showTimeDialog()"></button>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <!-- /.SEARCH -->
          <div class="box" [ngClass]="{'box-admin': consultationId != ''}">
            <!-- DETAIL INFO -->
            <div class="header info-detail-center bg-yellow-color" *ngIf="consultationId == ''">
              <div class="p-fluid p-formgrid p-grid">
                <div class="info-container">
                  <ng-container *ngIf="isMobile; else need">
                    <div class="p-fluid p-formgrid p-grid prefer-date">
                      <div class="p-col-7">
                        <span (click)="moveScreenByMatchType(matchId, listMatchChatDetail?.match_type, '0')"
                          class="bold prefer-first-date letter-spacing-1 text-orange">
                          <u>ふれあい体験希望内容</u>
                        </span>
                      </div>
                      <div class="p-col-5">
                        <span (click)="moveScreenByMatchType(matchId, listMatchChatDetail?.match_type, '1')"
                          class="bold prefer-first-date letter-spacing-1 text-orange">
                          <u>マッチング依頼内容</u>
                        </span>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #need>
                    <div class="p-fluid p-formgrid p-grid prefer-date">
                      <div class="p-col-4">
                        <span (click)="moveScreenByMatchType(matchId, listMatchChatDetail?.match_type, '0')"
                          class="bold prefer-first-date letter-spacing-1 text-orange">
                          <u>ふれあい体験希望内容</u>
                        </span>
                      </div>
                      <div class="p-col-4">
                        <span (click)="moveScreenByMatchType(matchId, listMatchChatDetail?.match_type, '1')"
                          class="bold prefer-first-date letter-spacing-1 text-orange">
                          <u>マッチング依頼内容</u>
                        </span>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
            <!-- /.DETAIL INFO -->
            <!-- CHAT LIST -->

            <div class="content chat-list" #chatList (scroll)="onScrollChat()"
              [ngClass]="{'chat-admin': listMatchChatDetail?.consultation_id != ''}">
              <ng-container *ngFor="let message of listChatDetail; index as i">
                <div class="row" [ngClass]="setClassBgColor(message)">
                  <ng-container *ngIf="numMsgEdit !== i; else EditMode">
                    <div [id]="'msg'+i" class="talk-bubble"
                      [ngClass]="{'enable-edit':listMatchChatDetail?.status != '4'}"
                      (click)="showEditChatMobile(i,listMatchChatDetail?.status)">


                      <!-- <p-overlayPanel #menu appendTo="body">
                        <ng-template pTemplate>
                          <div class="p-d-flex p-flex-column">
                            <button
                              pButton
                              icon="pi pi-pencil"
                              label="編集"
                              (click)="updateMsg(i, message)"
                              class="p-button-raised p-button-text p-button-plain"
                              tooltipPosition="bottom"
                            ></button>
                            <button
                              pButton
                              icon="pi pi-trash"
                              label="削除"
                              (click)="deleteMsg(i, message)"
                              class="p-button-raised p-button-text p-button-plain"
                              tooltipPosition="bottom"
                            ></button>
                          </div>
                        </ng-template>
                      </p-overlayPanel> -->
                      <div class="chat-hover" *ngIf="isLoginMember(message.chat_member_id_comment)">
                        <i class="pi pi-ellipsis-h p-pl-2 menu" (click)="menu.toggle($event);onClickMenu(i, message)"
                          [ngClass]="{'chat-menu-shown':menuIndex == i && isMobile}"></i>
                        <p-menu #menu [popup]="true" [model]="items" appendTo="body"></p-menu>
                      </div>
                      <div class="talktext">
                        <h5>
                          <span class="time">{{message.organization_name}}</span>
                        </h5>
                        <h5>
                          <span class="time" [innerText]="
                              formatTime(message.chat_create_datetime)
                            "></span>
                        </h5>
                        <p>
                          {{ message.chat_chat_comment }}
                        </p>
                        <div class="chat-img pointer" *ngIf="message.chat_image" [id]="'chatImg'+i">
                          <img [src]="message?.chat_image?.url" [alt]="message?.chat_image?.name" (load)="onImgLoad(i)"
                            (click)="viewImg(message?.chat_image?.url,message?.chat_image?.name)">
                        </div>
                        <div *ngIf="message.document != ''">
                          <a (click)="downloadFile(message?.chat_document?.url)">{{message?.chat_document?.name}}</a>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #EditMode>
                    <div class="modeEdit">

                      <div class="p-d-flex p-flex-column">
                        <div class="edit-box">
                          <textarea [(ngModel)]="chatContentEdit" maxlength="200" pInputTextarea autoResize="autoResize"
                            placeholder="" autocomplete="off" [id]="'editText'+i"></textarea>
                          <div class="edit-file p-col-12 p-pb-2 p-pl-6"
                            *ngIf="messEdit?.chat_image !== '' || messEdit?.chat_document !== ''">
                            <p-chip [label]="messEdit?.chat_image?.name" styleClass="custom-chip"
                              *ngIf="messEdit?.chat_image !== ''" [removable]="true"
                              (onRemove)="removeEditFile($event, message)"><i class="pi pi-image p-mr-2"></i></p-chip>
                            <p-chip [label]="messEdit?.chat_document?.name" styleClass="custom-chip"
                              *ngIf="messEdit?.chat_document !== '' && messEdit?.chat_document !== null"
                              [removable]="true" (onRemove)="removeEditFile($event, message)"><i
                                class="pi pi-file p-mr-2"></i></p-chip>
                          </div>
                        </div>
                      </div>
                      <div class="btn-confirm p-p-1">
                        <p-fileUpload [multiple]="false" maxFileSize="4000096" [showUploadButton]="false"
                          [showCancelButton]="false" [customUpload]="true" (onSelect)="
                                editFile(
                                  $event,
                                  message
                                )
                              " (focus)="_scrollToBottom()" chooseIcon="pi pi-paperclip" class="uploadfile"
                          accept="{{acceptedFiles}}">
                        </p-fileUpload>
                        <i class="pi pi-times" (click)="CancelEditMode2(message)"></i>
                        <i class="pi pi-check p-pl-2" (click)="editMessage(message, i, 'DB')"></i>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </ng-container>
              <!-- Message new of chat -->
              <!-- <ng-container *ngFor="let message of messageList; index as i">
                <div class="row" [ngClass]="setClassBgColor(message)">
                  <ng-container *ngIf="numMsgEdit !== i; else EditMode">
                    <div class="talk-bubble">
                      <p-overlayPanel #menu appendTo="body">
                        <ng-template pTemplate>
                         <div class="p-d-flex p-flex-column">
                          <button
                          pButton
                          icon="pi pi-pencil"
                          label="編集"
                          (click)="updateMsg(i, message)"
                          class="p-button-raised p-button-text p-button-plain"
                          tooltipPosition="bottom"
                        ></button>
                        <button
                          pButton
                          icon="pi pi-trash"
                          label="削除"
                          (click)="deleteMsg(i, message)"
                          class="p-button-raised p-button-text p-button-plain"
                          tooltipPosition="bottom"
                        ></button>
                         </div>
                        </ng-template>
                      </p-overlayPanel>
                      <div
                        class="chat-hover"
                        *ngIf="isLoginMember(message.chat_member_id_comment)"
                      >
                        <i
                          class="pi pi-ellipsis-h p-pl-2 menu"
                          (click)="menu.toggle($event)"
                        ></i>
                      </div>
                      <div class="talktext">
                        <h5>
                          <span
                            class="time"
                            [innerText]="
                              formatTime(message.chat_create_datetime)
                            "
                          ></span>
                        </h5>
                        <p>
                          {{ message.chat_chat_comment }}
                        </p>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #EditMode>
                    <div class="modeEdit">
                      <textarea
                      [(ngModel)]="chatContentEdit"
                      maxlength="200"
                      [rows]="1"
                      pInputTextarea
                      autoResize="autoResize"
                      [cols]="2"
                      placeholder=""
                    ></textarea>
                    <div class="btn-confirm p-p-1">
                      <i class="pi pi-times" (click)="cancelEdit()"></i>
                      <i class="pi pi-check p-pl-2" (click)="editMessage(message, i, 'DB')"></i>
                    </div>
                    </div>
                  
                  </ng-template>
                </div>
              </ng-container> -->
              <!-- ROW -->
              <!-- <ng-container *ngFor="let message of messageList">
                <div
                  class="row"
                  [ngClass]="
                    setClassBgColorSocket(message.memberId, message.classId)
                  "
                >
                  <div class="talk-bubble">
                    <div class="talktext">
                      <h5>
                        <span
                          class="time"
                          [innerText]="formatTime(message.timestamp)"
                        ></span>
                      </h5>
                      <p>
                        {{ message.content }}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-container> -->
              <!-- /.ROW -->
            </div>
            <!-- /.CHAT LIST -->
            <!-- CHAT TEXTAREA -->
            <div class="footer chat-input" *ngIf="listMatchChatDetail?.status !== '4' || consultationId != ''">
              <div class="p-grid p-pt-2 chat-input-content">
                <div class="input p-d-flex p-flex-column">
                  <div class="input-box">
                    <textarea [(ngModel)]="chatContent" [disabled]="sendingStt" maxlength="200" [rows]="2"
                      pInputTextarea placeholder="メッセージを入力してください。" autocomplete="off"></textarea>
                  </div>


                  <div class="p-col-12 file-display" *ngIf="fileUploadDocument || fileUploadedImage">
                    <p-chip [label]="fileUploadDocument.name" styleClass="custom-chip" *ngIf="fileUploadDocument"
                      [removable]="true" (onRemove)="removeFile($event)"><i class="pi pi-file p-mr-2"></i></p-chip>
                    <p-chip [label]="fileUploadedImage.name" styleClass="custom-chip" *ngIf="fileUploadedImage"
                      [removable]="true" (onRemove)="removeFile($event)"><i class="pi pi-image p-mr-2"></i></p-chip>
                  </div>
                </div>
                <div class=" button">
                  <div>
                    <p-fileUpload [multiple]="false" maxFileSize="4000096" [showUploadButton]="false"
                      [showCancelButton]="false" [customUpload]="true" (onSelect)="
                          uploadFile(
                            $event
                          )
                        " class="button" [disabled]="sendingStt" accept="{{acceptedFiles}}"
                      invalidFileSizeMessageSummary="" invalidFileSizeMessageDetail="登録失敗しました。ファイルは4MB以下までとなります"
                      invalidFileTypeMessageSummary=""
                      invalidFileTypeMessageDetail="画像のPNGまたはJPEGファイル、資料のExcel、Word文書またはPDFファイルのみアップロードしてください。">
                      <ng-template let-file pTemplate="file">
                        <div class="file-content" *ngIf="fileUploadedImage">
                          <div class="file_name">{{ fileUploadedImage.name }}</div>
                          <div>
                            <i class="pi pi-times" (click)="removeFile($event)"></i>
                          </div>
                        </div>
                        <div class="file-content" *ngIf="fileUploadDocument">
                          <div class="file_name">{{ fileUploadDocument.name }}</div>
                          <div>
                            <i class="pi pi-times" (click)="removeFile($event)"></i>
                          </div>
                        </div>
                      </ng-template>
                    </p-fileUpload>
                  </div>
                  <button class="send-msg-btn" [disabled]="sendingStt" pButton label="送信する"
                    (click)="sendMessage()"></button>
                </div>
              </div>
            </div>
          </div>
          <!-- /.CHAT TEXTAREA -->
        </div>
      </div>
      <!-- /.RIGHT CONTENT -->
    </div>
  </div>
</div>

<app-datetime-dialog *ngIf="isShowTimeDialog" (updateCloseDialog)="updateCloseDialog()"
  (returnDateSelect)="updateDateSelect($event)" [matchId]="matchId" [start_implementation_date]="
    this.c601ChatInputForm.get('start_implementation_date').value
  " [end_implementation_date]="
    this.c601ChatInputForm.get('end_implementation_date').value
  "></app-datetime-dialog>
<!-- Toastメッセージ表示 -->
<p-toast position="top-center"></p-toast>

<app-confirm-reject-match-dialog (reject)="cancelConfirm($event)" (isSuccess)="redirectListChat($event)"
  (numMsgEdit)="CancelEditMode($event)" (deletedId)="handleDeleteFromList($event)" (error)="reset()"
  (fail)="changeStatusFail()"></app-confirm-reject-match-dialog>

<app-c431-dialog *ngIf="isShowDialogC431" (returnStatusDialogC431)="closeDialogC431($event)" [matchId]="matchId"
  [match_type]="listMatchChatDetail?.match_type" (reloadData)="searchChatListCondition()" [isShowMatch]="isShowMatch"
  [matchInfo]="matchInfo"></app-c431-dialog>
<!-- <app-c341-dialog *ngIf="isShowDialogC341" (returnStatusDialogC341)="closeDialogC341($event)" [matchId]="matchId"
  (reloadData)="searchChatListCondition()"></app-c341-dialog> -->
<app-img-preview></app-img-preview>
<app-consultation-dialog (returnConsultationDialog)="closeConsultationDialog($event)">
</app-consultation-dialog>